<!-- 首页大底方案列表组件 -->
<template>
    <div>
        <!-- 标题栏 -->
        <van-row class="title-row" type="flex" justify="space-between">
            <van-col span="10">
                <i class="icon-box"></i>
                <span class="section-title">大底方案推荐</span>
            </van-col>
            <van-col class="col-right" span="14">
                <div @click="toRecommendForDadi()">
                <span>更多</span>
                <van-icon name="arrow" color="#9A9A9A" />
                </div>
            </van-col>
        </van-row>
        <!-- 列表区 -->
        <div class="case-list">
            <!-- 遍历item -->
            <div v-for="item in postList" class="case-item" @click="toDetail(item.id)">
                <!-- <van-divider
                    :style="{ color: '#1989fa', borderColor: '#F1F1F1', backgroundColor: '#F1F1F1', margin: '16px 0' }">
                </van-divider> -->
                <!-- 专家行 -->
                <van-row type="flex" justify="space-between" class="item-row">
                    <van-col span="11" class="col-center">
                        <van-image class="head-img" round fit="cover" width="24" height="24"
                            :src="'/img/headImg/' + item.headImg" />
                        <div style="width: 120px;" class="van-ellipsis font1">
                            {{ item.nickName }}
                        </div>
                    </van-col>
                    <van-col span="13" class="col-center algin-right">
                        <van-tag v-if="item.upIssueWinResult !== ''" plain type="danger">上期预测 ▪ 中{{
                            item.upIssueWinResult | commaFilter }}</van-tag>
                    </van-col>
                </van-row>
                <!-- 内容行 -->
                <van-row type="flex" justify="space-between" class="item-content">
                    <van-col span="24">
                        {{ item | titleFilter }}
                    </van-col>
                </van-row>
                <!-- 底部行 -->
                <van-row type="flex" justify="space-between" class="item-row">
                    <van-col span="18" class="col-center count-down font2">
                        <template v-if="!isEndFilter(item.endTime)">
                            倒计时
                            <van-count-down class="time font2" :time="item.endTime | countDownFilter" />
                        </template>
                        <template v-else>销售截止</template>
                    </van-col>
                    <van-col span="6" class="col-center algin-right money">
                        <div v-if="item.requiredAmount > 0">{{ item.requiredAmount }} 🪙</div>
                    </van-col>
                </van-row>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import { Icon, Image as VanImage, Col, Row, Tag, Divider, CountDown } from 'vant';

Vue.use(Icon);
Vue.use(VanImage);
Vue.use(Col);
Vue.use(Row);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(CountDown);

import dayjs from 'dayjs';

export default {
    name: 'CaseList',
    props: ['postList'],
    data() {
        return {
            time: 30 * 60 * 60 * 1000,
        };
    },
    filters: {
        // 如果没有标题，就以彩种名和期号为标题
        titleFilter(v) {
            if (v.title.trim() !== '') return v.title
            return v.nickName + v.lotteryName + '第' + v.issue + '期'
        },
        // 去掉逗号
        commaFilter(v) {
            return v.replace(/,/g, ' ')
        },
        // 倒计时秒数
        countDownFilter(v) {
            return dayjs(v).valueOf() - Date.now()
        },
    },
    methods: {
        // 点击帖子
        toDetail(id){
            this.$router.push({
                path: '/detail',
                query: {
                    id
                }
            })
        },

        // 更多大底方案
        toRecommendForDadi(){
            this.$router.push({
                path: '/recommend',
                query: {
                    areaId: 2
                }
            })
        },

        // 判断是否截止
        isEndFilter(v) {
            return dayjs(v).valueOf() <= Date.now()
        },
    }
}
</script>

<style scoped>
.case-item {
    background: #FFF3F3;
    border-radius: 8px;
    padding: 10px 16px;
    margin-top: 16px;
}

.van-tag--plain {
    padding: 2px;
}

/* 专家样式 */
.title-row {
    line-height: 20px;
}

.title-row .icon-box {
    display: inline-block;
    height: 20px;
    width: 8px;
    border-radius: 3px 0 0 3px;
    background-color: #F54B4A;
}

.title-row span.section-title {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    position: absolute;
    margin-left: 3px;
    font-size: 18px;
    font-weight: 700;
    color: #202020;
}

.title-row .col-right {
    text-align: right;
}

.title-row .col-right span {
    margin-right: 1px;
    font-size: 14px;
    font-weight: 500;
    color: #9A9A9A;
}

.item-row {
    height: 30px;
}

.head-img {
    margin-right: 5px;
}

.item-content {
    padding: 5px 0;
}

.count-down {
    color: #9A9A9A;
}

.money {
    color: #F54B4A;
    font-size: 16px;
}

.time {
    margin-left: 3px;
    color: #F54B4A;
}

.col-center {
    display: flex;
    align-items: center;
    height: 100%;
}

.font-middling {
    font-size: 13px;
}

.algin-right {
    justify-content: flex-end;
}
</style>